import { jsx as e, jsxs as n } from "react/jsx-runtime";
import { classnames as a } from "../utils/classnames.js";
import { attributes as i } from "../utils/attributes.js";
import '../../assets/Tabs.css';function p({ tabs: c, onTabChange: l, tabIndex: o }) {
  return /* @__PURE__ */ e("div", { className: "tabs", children: c.map((s, r) => /* @__PURE__ */ n(
    "div",
    {
      ...i({ "aria-selected": o === r }),
      className: a([s.className || ""]),
      onClick: () => l(r),
      children: [
        s.Icon && /* @__PURE__ */ e(s.Icon, {}),
        /* @__PURE__ */ e("span", { children: s.label }),
        s.IconAfter && /* @__PURE__ */ e(s.IconAfter, {})
      ]
    },
    s.label
  )) });
}
export {
  p as Tabs
};
//# sourceMappingURL=Tabs.js.map
